export type UserProfileSchema = {
    FirstName: string;
    MiddleName: string;
    LastName: string;
}

const nameofUserProfileSchemaFirstName = "FirstName";
const nameofUserProfileSchemaMiddleName = "MiddleName";
const nameofUserProfileSchemaLastName = "LastName";
const nameofUserProfileSchemaCollection = "UserProfile";

export {
    nameofUserProfileSchemaFirstName,
    nameofUserProfileSchemaMiddleName,
    nameofUserProfileSchemaLastName,
    nameofUserProfileSchemaCollection,
};

export type UserProfileView = UserProfileSchema & {
    Id: string;
};